// src/Rankings.tsx
import React, { useState, useEffect } from "react";
import { supabase } from "./supabaseClient";

const positions = ["PG", "SG", "SF", "PF", "C"];

export default function Rankings() {
  const [players, setPlayers] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [selectedPos, setSelectedPos] = useState("ALL");

  useEffect(() => {
    const fetchPlayers = async () => {
      try {
        const { data } = await supabase
          .from("players")
          .select("*")
          .order("value", { ascending: false });
        setPlayers(data || []);
        setLoading(false);
      } catch (err) {
        console.error(err);
        setLoading(false);
      }
    };
    fetchPlayers();
  }, []);

  const filtered = selectedPos === "ALL"
    ? players
    : players.filter(p => p.position === selectedPos);

  if (loading) {
    return (
      <div style={{ padding: "60px 20px", textAlign: "center", fontSize: "24px", color: "#546e7a" }}>
        Loading rankings...
      </div>
    );
  }

  return (
    <div style={{
      maxWidth: "1200px",
      margin: "0 auto",
      padding: "40px 16px",
      background: "white",
      borderRadius: "28px",
      boxShadow: "0 20px 60px rgba(0,0,0,0.08)",
      marginTop: "32px",
    }}>
      <h1 style={{
        fontSize: "48px",
        fontWeight: 900,
        background: "linear-gradient(135deg, #ff8a65 0%, #ff6f4a 100%)",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
        textAlign: "center",
        marginBottom: "32px",
      }}>
        Player Rankings
      </h1>

      {/* Position Filter */}
      <div style={{ display: "flex", justifyContent: "center", gap: "12px", marginBottom: "32px", flexWrap: "wrap" }}>
        {["ALL", ...positions].map(pos => (
          <button
            key={pos}
            onClick={() => setSelectedPos(pos)}
            style={{
              padding: "10px 20px",
              borderRadius: "12px",
              fontWeight: 700,
              fontSize: "14px",
              border: "none",
              backgroundColor: selectedPos === pos ? "#ff8a65" : "#f5f5f5",
              color: selectedPos === pos ? "white" : "#546e7a",
              cursor: "pointer",
              transition: "all 0.2s",
            }}
          >
            {pos === "ALL" ? "All Positions" : pos}
          </button>
        ))}
      </div>

      {/* Table */}
      <div style={{ overflowX: "auto" }}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr style={{ borderBottom: "3px solid #e0e0e0" }}>
              <th style={{ textAlign: "left", padding: "16px", fontWeight: 800, color: "#2c3e50", fontSize: "14px" }}>Rank</th>
              <th style={{ textAlign: "left", padding: "16px", fontWeight: 800, color: "#2c3e50", fontSize: "14px" }}>Player</th>
              <th style={{ textAlign: "left", padding: "16px", fontWeight: 800, color: "#2c3e50", fontSize: "14px" }}>Team</th>
              <th style={{ textAlign: "left", padding: "16px", fontWeight: 800, color: "#2c3e50", fontSize: "14px" }}>Pos</th>
              <th style={{ textAlign: "right", padding: "16px", fontWeight: 800, color: "#ff8a65", fontSize: "14px" }}>Value</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((p, idx) => (
              <tr key={p.id} style={{
                borderBottom: "1px solid #f0f0f0",
                backgroundColor: idx % 2 === 0 ? "#fafafa" : "white",
                transition: "background 0.2s",
              }}
              onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#fff5f0"}
              onMouseLeave={(e) => e.currentTarget.style.backgroundColor = idx % 2 === 0 ? "#fafafa" : "white"}
              >
                <td style={{ padding: "16px", fontWeight: 700, color: "#546e7a" }}>
                  {selectedPos === "ALL" ? idx + 1 : filtered.slice(0, idx).filter(x => x.position === p.position).length + 1}
                </td>
                <td style={{ padding: "16px", fontWeight: 700, color: "#2c3e50" }}>{p.name}</td>
                <td style={{ padding: "16px", color: "#7f8c8d" }}>{p.team}</td>
                <td style={{ padding: "16px", color: "#ff8a65", fontWeight: 700 }}>{p.position}</td>
                <td style={{ padding: "16px", textAlign: "right", fontWeight: 900, color: "#ff8a65", fontSize: "18px" }}>
                  {p.value}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {filtered.length === 0 && (
        <p style={{ textAlign: "center", color: "#b0bec5", fontStyle: "italic", marginTop: "40px" }}>
          No players found for {selectedPos}.
        </p>
      )}
    </div>
  );
}
